import React from 'react';
import Textfield from '../../../ui/text-field';
import Select from '../../../ui/select';

export default ({
    clin,
    deleteItem,
    item,
    index,
    vendors,
    disabled,
    saveSubmit
}) => {
    let clinIndex = +clin;
    return (
        <tr className="table__row">
            <td className="table__cell table__cell--first">
                <span className="table__cell-title">CLIN</span>
                <span className="table__cell-id">{clinIndex}</span>
                <i className="table__cell-icon" />
            </td>
            <td className="table__cell">
                <span className="table__cell-title">Vendor</span>
                <Select
                    model={`PurchaseRequest.PurchaseRequestItem[${index}].vendorId`}
                    options={vendors}
                    required
                    disabled={disabled}
                />
            </td>
            <td className="table__cell">
                <span className="table__cell-title">Item Name</span>
                <Textfield
                    model={`PurchaseRequest.PurchaseRequestItem[${index}].name`}
                    required
                    disabled={disabled}
                />
            </td>
            <td className="table__cell">
                <span className="table__cell-title">QTY</span>
                <Textfield
                    model={`PurchaseRequest.PurchaseRequestItem[${index}].quantity`}
                    type="number"
                    required
                    disabled={disabled}
                    onKeyPress
                    min="0"
                />
            </td>
            <td className="table__cell">
                <span className="table__cell-title">Price</span>
                <Textfield
                    model={`PurchaseRequest.PurchaseRequestItem[${index}].unitPrice`}
                    type="number"
                    required
                    disabled={disabled}
                    onKeyPress
                    min="0"
                />
            </td>
            <td className="table__cell">
                <span className="table__cell-title">Unit of Issue</span>
                <Textfield
                    model={`PurchaseRequest.PurchaseRequestItem[${index}].unitOfIssue`}
                    disabled
                    required
                />
            </td>
            <td className="table__cell">
                <span className="table__cell-title">Amount</span>
                <Textfield
                    model={`PurchaseRequest.PurchaseRequestItem[${index}].total`}
                    type="number"
                    required
                    disabled
                />
            </td>
            <td className="table__cell">
                <span className="table__cell-title">Line Item Description</span>
                <Textfield
                    model={`PurchaseRequest.PurchaseRequestItem[${index}].description`}
                    required
                    disabled={disabled}
                />
            </td>
            <td className="table__cell line-items">
                {saveSubmit ? (
                    <span
                        onClick={deleteItem}
                        className="line-items__btn"
                        data-index={index}
                    >
                        <svg className="icon icon-minus">
                            <use
                                xmlnsXlink="http://www.w3.org/1999/xlink"
                                xlinkHref="#icon-minus"
                            />
                        </svg>
                    </span>
                ) : null}
            </td>
        </tr>
    );
};



// WEBPACK FOOTER //
// ./src/components/event/purchase-request/basic-info-line-item/line-item.js